/**
 * Which modifier opens the palette. Detected from the platform rather than
 * configured, so the hint the topbar prints and the key the listener accepts can
 * never disagree.
 */
export function isMacPlatform(): boolean {
  if (typeof navigator === 'undefined') return false;

  return /Mac|iPhone|iPad|iPod/i.test(navigator.userAgent);
}

/** The key cap shown beside the search field — `⌘K` on macOS, `Ctrl K` elsewhere. */
export function shortcutLabel(): string {
  return isMacPlatform() ? '⌘K' : 'Ctrl K';
}
